<!--
  container-chips.component.html

  Tap a chip per container that arrived. Tapping the same chip again adds
  another of that type; tapping a second chip starts a second type. One chip per
  type, so the same containers can't be added twice under two names.

  Extracted verbatim from the mobile Details step so the log-edit screen adjusts
  containers with the same control the delivery was logged with.
-->

<!-- What the log will say. Preview only: the backend derives and stores the real
     string from the submitted pairs. Doubles as the instructions until there's
     something to show — the second line teaches the tap-again behavior, which a
     selected-looking chip doesn't advertise. -->
<div class="container-preview" *ngIf="showPreview" [class.container-preview-empty]="!quantityPreview">
  <span class="container-preview-value">{{ quantityPreview || 'Tap a container type below' }}</span>
  <span class="container-preview-total" *ngIf="totalContainers > 1">
    {{ totalContainers }} labels
  </span>
  <span class="container-preview-hint" *ngIf="totalContainers <= 1">
    Tap it again to add another
  </span>
</div>

<!-- Pill chips; an active one grows its running count and a "−" to walk it back down. -->
<div class="shelf-chips">
  <div *ngFor="let t of chipTypes"
       class="chip container-chip"
       [class.chip-active]="isTypeSelected(t)">
    <!-- One tap = one more of this type. -->
    <button type="button" class="container-chip-add" (click)="onTapType(t)">
      {{ chipLabel(t) }}
      <span class="container-chip-count" *ngIf="isTypeSelected(t)">{{ quantityForType(t) }}</span>
    </button>
    <!-- Walks the count back down; the last one deselects the chip. -->
    <button type="button" class="container-chip-remove"
            *ngIf="isTypeSelected(t)"
            [attr.aria-label]="'Remove one ' + chipLabel(t)"
            (click)="onUntapType(t)">
      <ion-icon name="remove-outline"></ion-icon>
    </button>
  </div>
</div>

<div class="card-subfield">
  <div class="card-subfield-header">
    <div class="card-subfield-label">Other type</div>
    <button type="button" class="custom-toggle-btn" (click)="toggleCustomUnit()">
      <ion-icon [name]="showCustomUnit ? 'close-outline' : 'add-outline'"></ion-icon>
      Custom
    </button>
  </div>

  <!-- A custom type joins the grid as its own chip, so it's adjusted the same way
       as a preset. A name that matches a chip already selected just counts one
       more of that chip. -->
  <div class="custom-unit-row" *ngIf="showCustomUnit">
    <input class="custom-unit-input"
           [(ngModel)]="customUnitDraft"
           (keyup.enter)="onAddCustomUnit()"
           aria-label="Custom container type"
           placeholder="e.g. cylinders, racks, panels…" />
    <button type="button" class="custom-unit-add" [disabled]="!canAddCustomUnit" (click)="onAddCustomUnit()">
      Add
    </button>
  </div>

  <div *ngIf="showCustomUnit && customUnitTooLong" class="field-error">
    <ion-icon name="alert-circle-outline"></ion-icon>
    Container type is too long (50 characters max)
  </div>
</div>
